import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptAisne02 = () => {
  return (
    <DepartmentTemplate
      department="Aisne"
      departmentNumber="02"
      cities="Laon, Saint-Quentin, Soissons, Château-Thierry"
      region="Hauts-de-France"
    />
  );
};

export default DeptAisne02;
